"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAltText = void 0;
var merch_components_1 = require("@carvana/merch-components");
var react_1 = __importDefault(require("react"));
var FavoriteVehicle_1 = __importDefault(require("../../FavoriteVehicle"));
var StatusTags_1 = __importDefault(require("../../Tags/StatusTags"));
var TileDataContext_1 = require("../../TileDataContext");
var TileDataContext_2 = require("../../TileDataContext");
var Wrapper = (0, merch_components_1.createComponent)('section', {
    className: 'relative box-border grid grid-flow-row grid-rows-[min-content,max-content]'
});
var StatusFavoriteWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'relative col-[1_/_3] grid'
});
var ImageWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'absolute bottom-0 top-0 block h-full w-full rounded-t-md bg-gradient-to-t from-[#EDF5F8] via-white to-white'
});
var tileImageClasses = 'h-full object-cover rounded-t-md w-full';
var getOptimizedUrl = function (url, width) {
    var separator = url.includes('?') ? '&' : '?';
    return "".concat(url).concat(separator, "width=").concat(width);
};
var useAltText = function () {
    var _a = (0, TileDataContext_2.useTileDataContext)().tileData, make = _a.make, year = _a.year, model = _a.model;
    return make && model && year ? "".concat(year, " ").concat(make, " ").concat(model) : '';
};
exports.useAltText = useAltText;
var useImageUrl = function () {
    var _a = (0, TileDataContext_2.useTileDataContext)(), _b = _a.tileData, stockNumber = _b.stockNumber, vehicleInventoryType = _b.vehicleInventoryType, jellyBeanMobileUrl = _b.jellyBeanMobileUrl, _c = _a.assets, cvnaVexFastlyImageUrl = _c.cvnaVexFastlyImageUrl, cvnaAppAssetsCdn = _c.cvnaAppAssetsCdn;
    var hasJellyBeanUrl = Boolean(jellyBeanMobileUrl);
    var hasStockNumber = Boolean(stockNumber);
    var isWip = vehicleInventoryType === TileDataContext_1.InventoryTypeId.WIP;
    if (!hasStockNumber && !hasJellyBeanUrl) {
        return "".concat(cvnaAppAssetsCdn, "/search-assets/noevox.png");
    }
    return isWip
        ? jellyBeanMobileUrl
        : "".concat(cvnaVexFastlyImageUrl, "/").concat(stockNumber, "/standardizedHero.jpg");
};
function ImageStatusFavorite() {
    var jellyBeanMobileUrl = (0, TileDataContext_2.useTileDataContext)().tileData.jellyBeanMobileUrl;
    var altText = (0, exports.useAltText)();
    var imageToUse = useImageUrl();
    var hasBlueSteel = imageToUse === jellyBeanMobileUrl;
    //TODO maybe the favorite component is a prop
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(ImageWrapper, { "data-qa": "vehicle-image" },
            react_1.default.createElement("img", { className: tileImageClasses, src: getOptimizedUrl(imageToUse, 500), alt: altText, loading: "lazy" }),
            hasBlueSteel && (react_1.default.createElement("span", { className: "absolute bottom-[5px] right-[25%] translate-y-[-75%] text-xs text-black" }, '\xA9  Carvana, LLC Stock Image'))),
        react_1.default.createElement(StatusFavoriteWrapper, null,
            react_1.default.createElement(StatusTags_1.default, null),
            react_1.default.createElement(FavoriteVehicle_1.default, null))));
}
exports.default = ImageStatusFavorite;
//# sourceMappingURL=ImageStatusFavorite.js.map